import { useQuery } from "@apollo/client";

import { gql } from "~/__generated__";

const FIELDWORKER_GET_AVAILABILITY_CONFIG = gql(`
    query FieldworkerGetAvailabilityConfig {
        fieldworkerGetAvailabilityConfig {
            id
            name
            period {
                startAt
                endAt
            }
            description
            availabilities {
            id
            name
            availabilityCategoryId
            description
            time
            minimumAvailability
            }
        }
    }
`);

export default function useFieldworkerGetAvailabilityConfig() {
    const { data, loading, error } = useQuery(FIELDWORKER_GET_AVAILABILITY_CONFIG, {});

    return {
        loading,
        error,
        data: data?.fieldworkerGetAvailabilityConfig,
    };
}
